// extracted by mini-css-extract-plugin
export default {"root":"VbR57e"};